module.exports = __webpack_public_path__ + "media/images/sp/items/gift/kiribako_03_thumb-542b6594cd8b18bbdfdeb61639883041.jpg";